import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { AudioLines, LogOut, Home } from "lucide-react";

export default function AppHeader() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <header className="sticky top-0 z-40 glass border-b border-white/5">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/app" className="flex items-center gap-2.5" data-testid="app-logo">
          <span className="grid place-items-center h-8 w-8 rounded-full bg-primary/15 text-primary"><AudioLines size={18} strokeWidth={1.5} /></span>
          <span className="font-serif text-lg">VoiceMatrix AI</span>
        </Link>
        <div className="flex items-center gap-2">
          <span className="hidden sm:block text-sm text-muted-foreground mr-2" data-testid="app-user-name">{user?.name}</span>
          <Button variant="ghost" size="sm" className="rounded-full text-secondary-foreground hover:text-primary" onClick={() => navigate("/")} data-testid="app-home-btn"><Home size={16} strokeWidth={1.5} /></Button>
          <Button variant="outline" size="sm" className="rounded-full border-border" onClick={async () => { await logout(); navigate("/"); }} data-testid="app-logout-btn"><LogOut size={16} strokeWidth={1.5} /> Logout</Button>
        </div>
      </div>
    </header>
  );
}
